import { AccountTaskService } from 'src/app/services/account/account-task.service';
import { Component, ElementRef, ViewChild, OnDestroy, OnInit, HostListener } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Subscription } from 'rxjs';
import { getTime } from 'date-fns';

import { PrivilegeService } from 'src/app/services/account/privilege/privilege.service';
import { FunctionService } from 'src/app/services/general/function.service';
import { AccountUserService } from 'src/app/services/account/account-user.service';
import { AccountInfoService } from 'src/app/services/account/account-info.service';
import { PopupService } from 'src/app/services/general/popup.service';
import { PhotoService } from 'src/app/services/general/photo.service';
import { AccountInfo, AccountUser } from 'src/app/interfaces/account';

import { AccountDetailType } from 'src/app/types/account';
import { ModuleType } from 'src/app/types/general';

import { AccountEventModeService } from 'src/app/services/account/account-event-mode.service';

import { AccountLoadingService } from 'src/app/services/account/account-loading.service';
import { AppRateService } from 'src/app/services/general/app-rate.service';
import { CurrentPrivilege } from 'src/app/interfaces/privilege';
import { WebsiteDetailService } from 'src/app/services/website/website-detail.service';
import { WebsiteDetail } from 'src/app/interfaces/website';
import { MediaType } from 'src/app/interfaces/general';
import { VisitorModeService } from 'src/app/services/visitor/visitor-mode.service';
import { ModalController } from '@ionic/angular';
import { WebsiteCoverListComponent } from 'src/app/components/website/setting/cover/website-cover-list/website-cover-list.component';
import { VisitorService } from 'src/app/services/visitor/visitor.service';


/**
 * Component
 */
@Component({
  selector: 'app-account-home',
  templateUrl: './account-home.page.html',
  styleUrls: ['./account-home.page.scss'],
})
export class AccountHomePage implements OnInit, OnDestroy {

  @HostListener('window:resize', ['$event'])onResize(event: any) {
    this.setupSlidePerView();
  }
  /**
   * Watch screen orientation change for login slider setup
   */
  @HostListener('window:orientationchange', ['$event']) onOrientationChange(event: any) {
    this.setupSlidePerView();
  }
  
  /**
   * Ion Card
   */
  @ViewChild('content', { read: ElementRef }) content: ElementRef;
  /**
   * Account info
   */
  accountInfo: AccountInfo;
  /**
   * Account userrea
   */
  accountUserList: AccountUser[];
  /**
   * days
   */
  days: number;
  /**
   * hours
   */
  hours: number;
  /**
   * minutes
   */
  minutes: number;

  reset: boolean;

  ready: boolean;

  /**
   * Online List
   */
  onlineList: any;

  totalChecklistCount: number;
  completedChecklistCount: number;

  slidePerView: number;

  currentPrivilege: CurrentPrivilege;

  websiteCover: MediaType;

  newWebsiteMode: boolean;

  private timeout: any;

  private counterFlag: boolean;
  /**
   * Time
   */
  private time: number;
  /**
   * Account info subscription
   */
  private accountInfoSubscription: Subscription;
  /**
   * Account user subscription
   */
  private accountUserSubscription: Subscription;

  private accountLoadingSubscription: Subscription;

  private accountTaskSubscription: Subscription;

  private privilegeSubscription: Subscription;

  private websiteDetailSubscription: Subscription;

  private visitorSubscription: Subscription;

  /**
   * Constructor
   */
  constructor(
    private router: Router,
    private translate: TranslateService,
    private modalController: ModalController,
    private photoService: PhotoService,
    private appRateService: AppRateService,
    private accountEventModeService: AccountEventModeService,
    private accountInfoService: AccountInfoService,
    private accountUserService: AccountUserService,
    private accountTaskService: AccountTaskService,
    private accountLoadingService: AccountLoadingService,
    private websiteDetailService: WebsiteDetailService,
    private visitorService: VisitorService,
    private visitorModeService: VisitorModeService,
    private privilegeService: PrivilegeService,
    private popupService: PopupService,
    private functionService: FunctionService
  ) { }

  ngOnInit(): void {
    this.reset = true;
  }

  ngOnDestroy(): void {
    this.reset = false;
    this.unwatch();
    this.stopTimeout();
  }

  /**
   * Before view enter
   */
  ionViewWillEnter() {
    this.reset = true;
    this.ready = false;
    this.accountUserList = [];
    this.counterFlag = true;
    this.counter();
    this.watch();
  }

  ionViewDidEnter() {
    this.setupSlidePerView();
    this.appRateService.checkAppRate();
  }

  ionViewWillLeave() {
    this.ready = false;
    this.unwatch();
    this.counterFlag = false;
    this.stopTimeout();
  }

  /**
   * Before view leave
   */
  ionViewDidLeave() {
    
  }

  watch() {
    this.watchVisitor();
    this.watchAccountInfo();
    this.watchAccountUser();
    this.watchAccountLoading();
    this.watchAccountTask();
    this.watchPrivilege();
    this.watchWebsiteDetail();
  }

  unwatch() {
    this.unwatchVisitor();
    this.unwatchAccountInfo();
    this.unwatchAccountUser();
    this.unwatchAccountLoading();
    this.unwatchAccountTask();
    this.unwatchPrivilege();
    this.unwatchWebsiteDetail();
  }

  async stopTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  /**
   * Watch account info
   */
  async watchAccountInfo() {
    if (!this.accountInfoSubscription) {
      this.accountInfoSubscription = this.accountInfoService.observableAccountInfo.subscribe((accountInfo: AccountInfo) => {
        this.accountInfo = accountInfo;
        
        if ((accountInfo?.time?.seconds * 1000) !== this.time) {
          if (accountInfo?.time?.seconds) {
            this.time = accountInfo.time.seconds * 1000;
          } else {
            this.time = 0;
          }
          this.setupDuration();
        }
      });
    }
  }

  /**
   * Unwatch account info
   */
  async unwatchAccountInfo() {
    if (this.accountInfoSubscription) {
      this.accountInfoSubscription.unsubscribe();
      this.accountInfoSubscription = null;
    }
  }

  /**
   * Watch account user
   */
  async watchAccountUser() {
    if (!this.accountUserSubscription) {
      this.accountUserSubscription = this.accountUserService.observableAccountUser.subscribe((accountUser: AccountUser[]) => {
        if (accountUser) {
          accountUser.sort((a: AccountUser, b: AccountUser) => {
            return this.functionService.compare(a.name, b.name);
          });
        }
        this.accountUserList = accountUser;
  
        this.checkUserOnline();
      });
    }
  }

  /**
   * Unwatch account user
   */
  async unwatchAccountUser() {
    if (this.accountUserSubscription) {
      this.accountUserSubscription.unsubscribe();
      this.accountUserSubscription = null;
    }
  }

  async watchAccountLoading() {
    if (!this.accountLoadingSubscription) {
      this.accountLoadingSubscription = this.accountLoadingService.observableReady.subscribe((ready: boolean) => {
        this.ready = ready;
        if (this.ready) {
          this.setupSlidePerView();
        }
      });
    } else {
      this.ready = this.accountLoadingService.getReady();
    }
  }

  async unwatchAccountLoading() {
    if (this.accountLoadingSubscription) {
      this.accountLoadingSubscription.unsubscribe();
      this.accountLoadingSubscription = null;
    }
  }

  async watchAccountTask() {
    if (!this.accountTaskSubscription) {
      this.accountTaskSubscription = this.accountTaskService.observableAccountTask.subscribe(() => {
        this.totalChecklistCount = this.getTotalChecklistCount();
        this.completedChecklistCount = this.getCompletedChecklistCount();
      })
    }
  }

  async unwatchAccountTask() {
    if (this.accountTaskSubscription) {
      this.accountTaskSubscription.unsubscribe();
      this.accountTaskSubscription = null;
    }
  }

  async watchPrivilege() {
    if (!this.privilegeSubscription) {
      this.privilegeSubscription = this.privilegeService.observableCurrentPrivilege.subscribe(() => {
        this.setupPrivilege();
      })
    }
  }

  async unwatchPrivilege() {
    if (this.privilegeSubscription) {
      this.privilegeSubscription.unsubscribe();
      this.privilegeSubscription = null;
    }
  }

  async watchWebsiteDetail() {
    if (!this.websiteDetailSubscription) {
      this.websiteDetailSubscription = this.websiteDetailService.observable.subscribe((websiteDetail: WebsiteDetail) => {
        if (websiteDetail?.theme?.cover?.media?.url) {
          this.websiteCover = websiteDetail.theme.cover.media;
        }
      });
    }
  }

  async unwatchWebsiteDetail() {
    if (this.websiteDetailSubscription) {
      this.websiteDetailSubscription.unsubscribe();
      this.websiteDetailSubscription = null;
    }
  }

  async watchVisitor() {
    if (!this.visitorSubscription) {
      this.visitorSubscription = this.visitorService.observablePageData.subscribe(() => {
        this.checkWebsiteMode();
      });
    }
  }
  
  async unwatchVisitor() {
    if (this.visitorSubscription) {
      this.visitorSubscription.unsubscribe();
      this.visitorSubscription = null;
    }
  }

  checkWebsiteMode() {
    this.newWebsiteMode = this.visitorModeService.checkNewWebsite();
  }

  setupPrivilege() {
    if (!this.currentPrivilege) {
      this.currentPrivilege = {};
    }
    this.currentPrivilege = {
      'account': {
        'view': this.checkPrivilege('account', 'view'),
      },
      'guest': {
        'view': this.checkPrivilege('guest', 'view'),
      },
      'checkin': {
        'view': this.checkPrivilege('checkin', 'view'),
      },
      'gift': {
        'view': this.checkPrivilege('gift', 'view'),
      },
    };
  }

  setupSlidePerView() {
    if (this.content?.nativeElement?.offsetWidth && this.ready) {
      this.slidePerView = this.getSlidesPerView();
    } else {
      setTimeout(() => {
        this.setupSlidePerView();
      }, 500);
    }
  }

  getCurrentUser(): AccountUser {
    return this.accountUserService.getCurrenctUser();
  }

  // getReady() {
  //   return this.accountLoadingService.getReady();
  // }

  /**
   * Setup duration
   */
  setupDuration() {
    if (this.time) {
      let date = (this.time - getTime(new Date())) / 1000;
      if (date > 0) {
        this.days = Math.floor(date / 86400);
        date -= this.days * 86400;

        this.hours = Math.floor(date / 3600) % 24;
        date -= this.hours * 3600;

        this.minutes = Math.floor(date / 60) % 60;
        date -= this.minutes * 60;
      } else {
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
      }
    } else {
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
    }
  }

  getSlidesPerView() {
    const itemWidth = 100;
    let maxSlide = 0;

    if (this.checkPrivilege('guest', 'view')) {
      maxSlide += 1;
    }
    if (this.checkPrivilege('checkin', 'view')) {
      maxSlide += 1;
    }
    if (this.checkPrivilege('gift', 'view')) {
      maxSlide += 1;
    }

    if (this.getTotalChecklistCount()) {
      maxSlide += 1;
    }

    let slidesPerView = maxSlide;
    let cardWidth = this.content?.nativeElement?.offsetWidth ? this.content.nativeElement.offsetWidth : window?.innerWidth;

    slidesPerView = Math.floor((cardWidth - 22) / itemWidth);
    if (!slidesPerView || slidesPerView < 1) {
      slidesPerView = 1;
    }
    if (slidesPerView >= maxSlide) {
      slidesPerView = maxSlide;
    } else {
      slidesPerView = slidesPerView + 0.2;
    }

    return slidesPerView;
  }

  /**
   * Counter
   */
  async counter() {
    await this.stopTimeout();
    this.timeout = setTimeout(() => {
      this.setupDuration();
      if (this.counterFlag) {
        this.counter();
      }
    }, 1000);
  }

  getTotalChecklistCount(): number {
    // console.log(this.accountTaskService.accountTaskList?.length)
    return this.accountTaskService?.accountTaskList?.length;
  }

  getCompletedChecklistCount(): number {
    return this.accountTaskService.completed;
  }

  /**
   * Present Title Prompt
   */
  async presentTitlePrompt() {
    if (this.checkPrivilege('account', 'edit')) {
      const text = this.accountInfo?.title?.value ? this.accountInfo.title.value : '';
      const modal = await this.popupService.presentInput(this.translate.instant('LBL.title'), '', '', '', text, true);
      modal.onDidDismiss().then((result: any) => {
        const value = result?.data?.input?.toString()?.trim();
        if (value) {
          if (value !== this.accountInfo?.title?.value) {
            const custom = value === this.translate.instant('ACCOUNT.auto_title', {
              couple1: this.accountInfo.coupleList[0].name, couple2: this.accountInfo.coupleList[1].name
            }) ? false : true;
            const title = {
              value,
              custom
            };
            this.saveDB({ title });
          }
        }
      });
    }
  }

  async presentCoverListModal() {
      const modal = await this.modalController.create({
        component: WebsiteCoverListComponent,
        // cssClass: 'modal-transparent',
        componentProps: {
          selected: { ...this.websiteCover },
        }
      });
      modal.present();
      modal.onWillDismiss().then((result?: any) => {

      }); 
    }

  /**
   * Select photo
   */
  async selectPhoto() {
    if (this.checkPrivilege('account', 'edit')) {
      if (this.newWebsiteMode) {
        if (this.checkPrivilege('website', 'contents')) {
          this.presentCoverListModal();
        }
      } else {
        this.photoService.selectPhoto('account_gallery', true);
      }
    }
  }


  /**
   * Check user privilege
   * @param action Action
   */
  checkPrivilege(module: ModuleType, action: string): boolean {
    // console.log(this.privilegeService.checkCurrentUserPrivilege(module, action));
    return this.privilegeService.checkCurrentUserPrivilege(module, action);
  }

  checkUserOnline() {
    const onlineList: any = {};
    if (this.accountUserList?.length) {
      this.accountUserList?.forEach((user: any) => {
        onlineList[user.uid] = {};
        onlineList[user.uid].online$ = this.accountUserService.getPresence(user.uid);
      });
    }
    this.onlineList = onlineList;
  }

  /**
   * Save DB
   * @param data data
   */
  async saveDB(data: any) {
    await this.popupService.presentLoading();
    if (data) {
      await this.accountInfoService.updateAccountInfo(data);
    }
    this.popupService.dismissLoading();
    this.popupService.saveSuccessToast();
  }

  doRefresh(event: any) {
    this.reset = false;
    setTimeout(() => {
      this.reset = true;
      event.target.complete();
    }, 500);
  }

  goAccountDetailPage(detailType?: AccountDetailType) {
    const navigationExtras: NavigationExtras = {
      state: {
        detailType
      }
    };
    this.router.navigate(['/account/detail'], navigationExtras);
  }

  goAccountTaskPage() {
    this.router.navigate(['/account/accountTask']);
  }

  replaceEventType(text: string) {
    return this.accountEventModeService.replaceEventType(text);
  }
}
